import { StateSchema } from 'app/config/storeConfig/types';

export const getOpenedUserId = (state: StateSchema): Nullable<string> => state.completeRegistrationModal.userId;
